interface RatingAnchorOption {
    /** A dictionary keeps its numeric code here (2, not "2"), whatever the type says. */
    value: string | number;
    label: string;
}

/** "10 = Worst possible" for value 10 gives "Worst possible"; a label that is just the number gives "". Else null. */
function anchorWords(option: RatingAnchorOption): string | null {
    const label = String(option.label ?? "").trim();
    if (label === "" || label === String(option.value)) return "";
    const match = label.match(/^(-?\d+(?:\.\d+)?)\s*=\s*(.+)$/);
    if (!match || Number(match[1]) !== Number(option.value)) return null;
    return match[2]!.trim();
}

/**
 * A numeric 0-10 scale whose labels are its numbers, some with words ("0 = None", "1 = Very mild", "2", ...,
 * "10 = Worst possible", as the Rateing_1 dictionary has). The buttons already show the numbers, so the words
 * go in a key under the scale instead of under each narrow button: the low half under the left end, the high
 * half under the right. Null when any label is something else, or none has words, so other scales are unchanged.
 */
export function ratingAnchorLines(options: readonly RatingAnchorOption[]): { low: string[]; high: string[] } | null {
    const numeric = options.filter((option) => option.value !== "");
    if (numeric.length === 0 || numeric.some((option) => !Number.isFinite(Number(option.value)))) return null;
    const values = numeric.map((option) => Number(option.value));
    const middle = (Math.min(...values) + Math.max(...values)) / 2;

    const low: string[] = [];
    const high: string[] = [];
    for (const option of [...numeric].sort((a, b) => Number(a.value) - Number(b.value))) {
        const words = anchorWords(option);
        if (words === null) return null;
        if (words) (Number(option.value) <= middle ? low : high).push(`${option.value} = ${words}`);
    }
    return low.length || high.length ? { low, high } : null;
}
